import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CustomDatePicker from '../components/CommonDatePicker';
/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/
import CommonButton from '../components/CommonButton';

class SearchUserDataExternalUser extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation, UserCookie } = props;

        let { fullname, start_register_date, end_register_date, position_id, email, contact, username, status } = Searchs;

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">                 
                        <Row className="mt-3">
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{fullname.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={fullname}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                        disabled={!['0', '1'].includes(UserCookie?.types)}
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{position_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={position_id}
                                        option={{source: 'db', data: Masterbase?.position}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                        disabled={false}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{username.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={username}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>   
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{email.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={email}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>  
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{contact.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={contact}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>                    
                        </Row>
                        <Row>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">ลงทะเบียน</InputGroup.Text>
                                    <div className="form-control p-0 border-0">
                                        <CustomDatePicker 
                                        element="Searchs"
                                        input={start_register_date}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                        />
                                    </div>
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">ถึง</InputGroup.Text>
                                    <div className="form-control p-0 border-0">
                                        <CustomDatePicker 
                                            element="Searchs"
                                            input={end_register_date}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 
                                        />
                                    </div>
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={status}
                                        option={{source: 'options', section: 'status', item: 'external_user'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchUserDataExternalUser;